import { render } from "./channels.vue?vue&type=template&id=45ecb44e"
import script from "./channels.vue?vue&type=script&lang=js"
export * from "./channels.vue?vue&type=script&lang=js"

import "./channels.vue?vue&type=style&index=0&id=45ecb44e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__